export default {
    summary_text: 'Seu resumo EcoCredits',
    membership: 'MEMBRO',
    current_tier: 'Nível atual',
    points: 'EcoCredits',
    points_balance: 'Saldo de EcoCredits',
    points_progress_tips: 'EcoCredits necessários para chegar a {plus}: {points} EcoCredits',
    coming_soon: 'Em breve',
    redeem_now: 'RESGATE AGORA',
    points_activity: 'ATIVIDADE POR PONTOS',
    how_it_works: 'Como funciona',
    already_member: 'Já é membro?',
    already_member1: 'Já é membro?',
    sign_up: 'Inscreva-se',
    sign_up_desc: 'Crie uma conta e receba 500 EcoCredits como recompensa.',
    sign_up_desc_h: '500 EcoCredits na inscrição.',
    earn_points: 'GANHE EcoCredits',
    earn_points_desc: 'Ganhe EcoCredits todas as vezes que você fizer compras.',
    redeem_points: 'RESGATE EcoCredits',
    redeem_points_desc: 'Resgate EcoCredits para descontos exclusivos.',
    earn_points_title: 'Maneiras de ganhar EcoCredits',
    sign_up_text: '500 EcoCredits na inscrição',
    completed_text: 'Você já conquistou essa recompensa.',
    subscribe: 'Assine',
    subscribe_capital_letters: 'Assine',
    subscribe_text: 'Assine a newsletter da EcoFlow.',
    subscribe_hover: 'Ganhe 500 EcoCredits na inscrição.',
    subscribe_now: 'Assine agora',
    email_address: 'Endereço de e-mail',
    shop: 'Compras',
    shop_capital_letters: 'Compras',
    earn_point_by_order: 'Ganhe a cada vez que você fizer um pedido.',
    earn_point_rule_shop: 'Receba 1 EcoCredits a cada R$ 0.2 gasto.',
    shop_to_earn_points: 'Compre para ganhar EcoCredits',
    warranty: 'Garantia',
    warranty_capital_letters: 'Garantia',
    warranty_desc1: '1.000 EcoCredits quando você registra um produto.',
    warranty_desc2: '1.000 EcoCredits quando você registra um produto.',
    profile: 'Perfil',
    profile_desc1: 'Ganhe até 1.000 EcoCredits ao preencher seu perfil.',
    profile_desc2: 'Ganhe até 1.000 EcoCredits para adicionar suas informações.',
    complete_profile: 'Preencha seu perfil',
    referral: 'Convide um amigo',
    referral_desc: 'Ganhe EcoCredits para cada amigo que se inscrever.',
    referral_btn: 'Inscreva-se agora',
    redeem_ecocredits_title: 'Resgate recompensas com EcoCredits',
    have_points: 'Você tem <code>{points} EcoCredits</code>',
    view_all: 'Ver tudo',
    coupon: 'Código de desconto',
    discount: 'Desconto',
    gift_card: 'Vale-presente',
    redeemed_succ: 'Resgatados com sucesso!',
    copy_desc: 'Você já copiou o código. Vá até a loja para usá-lo.',
    store: 'Inscreva-se agora',
    coupon_used_desc: 'Use este código no fechamento da compra para resgatar seu vale-presente de {amont}.',
    rules: 'Regras',
    off: 'DESCONTO',
    site_rules: 'Apenas para loja na BR.',
    days_rules: 'Válido por {days} dias a partir do resgate.',
    product_rules: 'Apenas para {product}.',
    days_rules2: 'Válido a partir de {data}.',
    lucky_rewards_list: 'Lista de recompensas',
    rewards_redeemed: 'Minhas recompensas',
    redeedmed_tab_name: 'Resgatados',
    issued_tab_name: 'Emitidos',
    available: 'Disponível',
    redeemed: 'Resgatados',
    expired: 'Expirados',
    edeemed_rewards_note: 'Suas recompensas resgatadas aparecerão aqui.',
    browse_ecocredits_rewards: 'Navegue pelas recompensas EcoCredits',
    used: 'Usados',
    give_away: 'Distribuídos',
    or_text: 'OU',
    send_your_friend: 'Envie seu vale-presente de {amont} para um amigo.',
    points_activity_a: 'Minha atividade',
    points_tab_name: 'Atividade de EcoCredits',
    rewards_tab_name: 'Atividade de recompensas',
    date: 'Data',
    action: 'Ação',
    rewards_title: 'Recompensas',
    type_title: 'Tipo',
    discount_type: 'Desconto',
    purchase: 'Compra',
    profile_a: 'Perfil',
    refund: 'Reembolso',
    registered: 'Registrados',
    points_capital_letters: 'EcoCredits',
    status: 'Status',
    pending: 'Pendentes',
    received: 'Recebidos',
    deducted: 'Deduzidos',
    view_more: 'Ver mais',
    history_note: 'Sua atividade de EcoCredits aparecerá aqui. Ainda não está vendo seus EcoCredits? Sua atividade será atualizada em 24 horas.',
    lucky_flop_start: 'Inscreva-se agora',
    lucky_flop_congrat: 'Parabéns',
    lucky_flop_get: 'Reivindicar',
    lucky_flop_open: 'ABRIR',
    ecoflow_benefits: 'Benefícios EcoCredits',
    membership_includes: 'A ASSINATURA INCLUI',
    see_t_c: 'Veja os termos e condições',
    manually_added: 'Adicionado manualmente',
    manually_deducted: 'Deduzido manualmente',
    faq_title: 'Perguntas frequentes',

    redeeming_points: 'COMO RESGATAR EcoCredits',

    network_error: 'Erro de rede',
    confirm_text: 'Tem certeza de que deseja resgatar? Não pode ser desfeito.',
    confirm_btn: 'Confirmar',
    no_enough_points: 'Erro no resgate, não há EcoCredits suficientes',
    no_history_note: 'Ainda não está vendo seus EcoCredits? Sua atividade será atualizada em 24 horas.',
    no_coupon_note: 'Nenhuma recompensa resgatada ainda.',
    minimum_price: 'Valor mínimo de compra ({price}).',
    minimum_num: 'Quantidade mínima de itens ({num} pçs).',
    stay_too_long: 'Sua sessão expirou. Atualize a página e tente de novo.',
    order_rule: 'Apenas um código de desconto por pedido.',
    purchas_rule: 'Comprar um item por menos que o(s) cupom(ns) cancelará a diferença.',
    profile_birthday: 'Perfil: aniversário',
    profile_address: 'Perfil: endereço',
    profile_username: 'Perfil: nome de usuário',
    profile_picture: 'Perfil: foto',
    profile_contact: 'Perfil: informações de contato',
    learn_more: 'Saiba mais',
    profile_detail:
        'Preencha seu perfil para ganhar até 1.000 EcoCredits, incluindo foto de perfil (200), nome de usuário (100), informações de contato (300), endereço (200) e aniversário (200).',
    exceeded_counts: 'Não foi possível o resgate. Você excedeu o limite de resgates.',
    grab_title: 'Pegue um Bônus EcoCredits',
    grab_sub_title: 'Ofertas exclusivas por tempo limitado para membros EcoCredit. Clique agora para solicitar!',
    grab_btn_text: 'Pegar meu bônus',
    grab_success_title: 'Parabéns',
    grab_success_text1: 'Bônus solicitado com sucesso!\nCole o código no fechamento da compra para conseguir seu desconto.',
    grab_success_text2: 'Veja seus bônus em <code>Minhas recompensas</code>.',
    'no-grab-content-note': 'Mais ofertas em breve!',
    copy_desc_2: 'Você copiou o código.',
    city_validatino_error: 'Cidade inválida',
    product_text: 'Produto',
    shipping_address_text: 'Endereço de envio',
    saved_address_text: 'Endereço salvo',
    use_new_address: 'use um novo endereço',
    spend_now: 'Gaste agora',
    stock_left: '{stock} restante',
    no_stock_tip: 'Em breve… Fique de olho!',
    order_text: 'Pedido',
    campaign_time_limit_text: 'Período de resgate válido entre {startTime} e {endTime}.',
    event_action_text: 'Evento',
    warranty_minus_action_text: 'Garantia excluída',
    question_correctly: 'Responda à pergunta corretamente',
    referral_correctly: 'Programa de indicação',
    confirm_btn_text: 'Fechar',
    member_only_title: 'Membe-Only prices products',
    member_only_subtitle: 'Unlock member-only rewards',
    member_only_off: 'DESCONTO',
    member_only: 'Exclusivo para membros',
    member_only_non: 'Non-member price',
    member_only_link: 'Browse the Entire Sale',
    member_only_prices: 'Member-Only Prices',
    lucky_turntable_title: 'Roleta da Sorte',
    join_lucky_with_points: 'Custa {points} EcoCredits para uma rodada da Roleta da Sorte.',
    join_lucky_with_points2: 'Custa {points} EcoCredits para jogar uma rodada.',
    join_lucky_desc: 'Gire a Roleta e receba um grande prêmio!',
    remaining_number: '<code></code> rodadas restantes',
    remaining_number2: '<code></code> giros restantes',
    learn_lucky_rule: 'Saiba mais sobre as regras',
    prize_coupon_title: 'Parabéns',
    prize_coupon_sub_title: 'O prêmio foi solicitado com sucesso! Use o código no fechamento para salvar.',
    prize_coupon_action: 'Veja seus prêmios em <code>Minhas recompensas</code>.',
    prize_coupon_button: 'Comprar agora',
    prize_points_title: 'Parabéns',
    prize_points_desc: 'Verifique os EcoCredits recém-adicionados em <code>Minha atividade</code>.',
    limit_times_in_day: 'Você pode girar a roleta <count></count> vezes em <day></day> dias',
    limit_times_in_day2: 'Você pode virar as cartas <count></count> vezes em <day></day> dias',
    limit_times_in_active: 'Durante o evento, você pode girar a roleta até <count></count> vezes.',
    limit_times_in_active2: 'Durante o evento, você pode virar as cartas até <count></count> vezes.',
    without_limit_times: 'Você pode girar a roleta <count></count> vezes a qualquer momento.',
    without_limit_times2: 'Você pode virar as cartas <count></count> vezes a qualquer momento.',
    active_is_unstart: 'Este evento acontecerá em breve.',
    active_is_ended: 'Este evento terminou.',
    over_max_count: 'Você excedeu o número de giros disponível.',
    notice_title: 'Aviso',
    points_cash: 'Resgate de pontos',
    Pending1: 'Pendentes',
    rollback: 'Devolvidos',
    level_change_log: 'Nível de atividade',
    deadline: 'Válidos até',
    history_refresh_member: 'Nível atual: Membro',
    history_refresh_plus_member: 'Nível atual: Membro PLUS',
    register: 'Registrar como Membro',
    upgrade: 'Atualizar para Membro PLUS',
    demotion: 'Voltar para Membro',
    relegation: 'Manter-se como Membro PLUS',
    ecocredits_notice1:
        'Atualizamos as regras dos EcoCredits em 17 de outubro de 2024. Leia atentamente nossas [<line1>regras dos EcoCredits</line1>] atualizadas antes de usar seus EcoCredits.',
    wattayear_2024: 'Share#WattAYear',
    site_account_profile_save_success: 'Sucesso',
    not_eligible: 'Você não é elegível para participar deste evento.',
    faq_tab_all: 'Todas as perguntas',
};
